import Page from '../components/Page'
import Section from '../components/Section'
import Support from '../components/Support'
import Paragraphs from '../components/Paragraphs'
import PrimaryTitle from '../components/PrimaryTitle'
import SmallCard from '../components/SmallCard'
import TinyLink from '../components/TinyLink'
import paths from '../path'

const pageTitle = 'neomento - Klinische Psychologie trifft Virtual Reality'

const project = {
  title: 'Über uns – Projekt neomento',
  paragraphs: [
    'Das Projekt neomento entstand 2017 in Berlin und Magdeburg am Deutschen Zentrum für Neurodegenerative Erkrankungen und war bis 2021 auch an der Charité in Berlin ansässig. Durch Fördermittel der EU und des Bundes konnte ein auf klinischen Erkenntnissen basierender neuartiger Therapieansatz entwickelt werden, der nun unter dem Namen neomento an Therapeuten, Kliniken und Universitäten weitergegeben werden kann. Eine entscheidende Grundlage des Projektes ist die enge Zusammenarbeit zwischen Forschern, Entwicklern und Therapeuten.',
  ],
}

const concept = {
  title: 'Konzept von neomento',
  paragraphs: [
    'Dank unserer umfangreichen Expertise in den Bereichen Klinische Forschung und Anwendung, VR-Entwicklung, Informationstechnologie und Messdiagnostik, achten wir in unserer Arbeit insbesondere auf eine sinnvolle Übersetzung therapeutischer Konzepte in praxistaugliche Technologien. Der Fokus liegt für uns klar bei den Anwendern und Betroffenen. Wir wollen einen maximal positiven Impact unserer VR-Therapie-Software schaffen und wertvolle Expositionen, Übungen und Trainings zum Alltag klinischer Praxis machen.',
    'Ohne wiederholtes Üben und Variation ist ein Transfer bestimmter Therapieinhalte kaum denkbar. Im Alltag psychotherapeutischer Arbeit ist in-vivo Therapie jedoch oft nicht umsetzbar. Dieses Dilemma kann VR ein Stück weit lösen. Doch auch wenn VR-T aktuell noch primär zur Substitution von in vivo Therapie genutzt wird, so birgt diese Technologie noch viel weitergehende therapeutische Möglichkeiten. Gemeinsam mit TherapeutInnen und PatientInnen möchte neomento diese Aussicht verwirklichen.'
  ],
  cta: 'Erfahren Sie mehr zu den Inhalten neomentos >',
  ctaHref: paths.product
}

const therapy = {
  title: 'Entwicklung innovativer VR-Therapie',
  paragraphs: [
    'Bei der Entwicklung unserer Software setzen wir auf besonders hochwertige und zukunftsorientierte Technologien und erweitern so die neomento VR-T ständig um neue Inhalte und Anwendungsoptionen. Wir glauben daran, dass eine hochwertige und wirksame Psychotherapie, insbesondere bei ausgeprägter Symptomatik, primär in einem klinischen Setting durchgeführt und durch TherapeutInnen begleitet werden sollte. Daher soll neomento TherapeutInnen zur Verfügung gestellt werden, um so die therapeutischen Optionen um eine Komponente zu erweitern: VR-Therapie. Denn wir sind davon überzeugt, dass VR-Therapie schon bald zum Standard wird. Gemeinsam mit Patientinnen im virtuellen Raum arbeiten und innerhalb des Therapiezimmers eindrückliche Erlebnisse schaffen zu können ist ein unglaublich wertvoller Gedanke.',
    'Das Angebot von Szenarien und Applikationen wird ständig erweitert. Sämtliche Einnahmen fließen direkt in die Entwicklung weiterer Inhalte und Funktionen. Im Rahmen verschiedener Projektbausteine und Forschungskooperationen arbeiten wir außerdem an der Integration physiologischer Messdaten sowie an völlig neuen technologiegestützten Therapiemethoden. Virtuelle Erlebnisse verfügbar, individualisierbar und messbar zu machen ist in unseren Augen ein wichtiger Schritt für die Weiterentwicklung moderner Psychotherapie.'
  ],
  cta: 'Mehr zur Evidenz >',
  ctaHref: paths.science
}

const management = {
  title: 'Management Team',
  people: [
    { name: 'Philipp Stepnicka', title: 'Chief Executive Officer', imgSrc: "/team/philipp.png", imgAlt: "Philipp Stepnicka" },
    { name: 'Dr. Adam Streck', title: 'Chief Technology Officer', imgSrc: "/team/adam.png", imgAlt: "Dr. Adam Streck" },
    { name: 'Prof. Thomas Wolbers', title: 'Chief Science Officer', imgSrc: "/team/thomas.png", imgAlt: "Prof. Thomas Wolbers" },
  ],
}

const media = {
  title: 'Medien',
  links: [
    { title: 'ARD-Reportage (ab 28:00)', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.daserste.de/information/reportage-dokumentation/rabiat/videos/republik-der-angst-folge-5-video-100.html' },
    { title: 'RBB-Reportage', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.rbb-online.de/rbbpraxis/archiv/20220216_2015/angst-psychische-stoerung-phobie-hilfe-therapie-vr-virtualreality-gamification-anzeichen-depression-panik-herzrasen-schweiss-zittern-kontakt.html' },
    { title: 'Magazin der IHK Berlin (S. 28)', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.ihk-berlin.org/ebook/Berliner-Wirtschaft-04-2021/2/' },
    { title: 'Gründerzentrum Uni Magdeburg', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.tugz.ovgu.de/home/News+aus+dem+TUGZ/Virtual+Reality+in+der+Psychotherapie.html' },
    { title: 'Digital Hub Rhein-Nekar', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.5-ht.com/2020/12/03/virtuell-menschen-helfen-vr-technologie-fuer-expositionstherapien-nutzen/' },
    { title: 'Startup-Mitteldeutschland', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://startup-mitteldeutschland.de/neomento-high-end-virtual-reality-loesungen-fuer-die-psychotherapie/' },
    { title: 'Ärzteblatt', imgSrc: 'articlePlaceholder.png', imgAlt: 'Media', btnTitle: 'Lesen', btnHref: 'https://www.aerzteblatt.de/nachrichten/87615/Mit-VR-Brille-gegen-Angstzustaende' },
  ]
}

export default function About() {
  return (
    <Page title={pageTitle}>
      <Section partialWidth>
        <div>
          <PrimaryTitle title={project.title} />
          <Paragraphs paragraphs={project.paragraphs} />
        </div>
      </Section>
      <img className="w-full" src="/headsetCloseup.png" alt="" />
      <Section partialWidth>
        <div>
          <div>
            <PrimaryTitle title={concept.title} />
            <Paragraphs paragraphs={concept.paragraphs} />
          </div>
          <div className="pt-8">
            <TinyLink href={concept.ctaHref}>{concept.cta}</TinyLink>
          </div>
        </div>
      </Section>
      <Section dark>
        <div className="flex flex-col sm:flex-row sm:space-x-20">
          <div className="w-full sm:w-1/3 md:w-2/4 sm:text-right">
            <PrimaryTitle hero title={therapy.title} />
          </div>
          <div className="w-full sm:w-2/3 md:w-2/4">
            <Paragraphs paragraphs={therapy.paragraphs} />
            <div className="pt-8">
              <TinyLink href={therapy.ctaHref}>{therapy.cta}</TinyLink>
            </div>
          </div>
        </div>
      </Section>
      <Section>
        <PrimaryTitle center title={management.title}></PrimaryTitle>
        <div className="sm:flex sm:space-x-4 sm:space-y-0 space-y-4 justify-center">
          {management.people.map((person) => (
            <div key={`person-${person.name}`}>
              <SmallCard title={person.name} description={person.title} imgSrc={person.imgSrc} imgAlt={person.imgAlt} />
            </div>
          ))}
        </div>
      </Section>
      <Section>
        <PrimaryTitle center title={media.title}></PrimaryTitle>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-8">
          {
            media.links.map((link, index) => (
              <div className="flex-1" key={`media-link-${index}`}>
                <SmallCard truncate title={link.title} btnTitle="Lesen" btnHref={link.btnHref}></SmallCard>
              </div>
            ))
          }
        </div>
      </Section>
      <Section>
        <Support />
      </Section>
    </Page>
  )
}
